var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-form-checkbox',{attrs:{"disabled":_vm.isDisabled},on:{"input":_vm.changeState},model:{value:(_vm.deletePassenger),callback:function ($$v) {_vm.deletePassenger=$$v},expression:"deletePassenger"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }